import script from "./WagersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WagersView.vue?vue&type=script&setup=true&lang=ts"

import "./WagersView.vue?vue&type=style&index=0&id=5e01070a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e01070a"]])

export default __exports__